// ==========================================
// NATIVE SETTINGS HELPER
// Öffnet System-Einstellungen in nativer App
// ==========================================

import { Capacitor } from '@capacitor/core';
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';

/**
 * Prüft ob App als native App läuft (nicht im Browser)
 */
export const isNativeApp = () => {
  return Capacitor.isNativePlatform();
};

/**
 * Öffnet die Standort-Einstellungen des Geräts
 * Nur in nativer App verfügbar!
 */
export const openLocationSettings = async () => {
  if (!isNativeApp()) {
    console.warn('⚠️ Native Settings nur in App verfügbar');
    return false;
  }
  
  try {
    const platform = Capacitor.getPlatform();
    
    if (platform === 'android') {
      // Android: Öffne Location Settings
      await NativeSettings.open({
        optionAndroid: AndroidSettings.Location,
      });
    } else if (platform === 'ios') {
      // iOS: Öffne App-spezifische Settings
      await NativeSettings.open({
        optionIOS: IOSSettings.App,
      });
    }
    
    return true;
  } catch (error) {
    console.error('❌ Fehler beim Öffnen der Einstellungen:', error);
    return false;
  }
};

/**
 * Zeigt Platform-spezifische Anleitung
 */
export const getLocationPermissionInstructions = () => {
  if (!isNativeApp()) {
    // Browser
    return '🔒 GPS blockiert!\n\n' +
      '1️⃣ Tippe auf das Schloss-Symbol 🔒 in der Adressleiste\n' +
      '2️⃣ Wähle "Standort" → "Erlauben"';
  }
  
  const platform = Capacitor.getPlatform();
  
  if (platform === 'android') {
    return '🔒 GPS-Berechtigung erforderlich!\n\n' +
      'Tippe auf "Einstellungen öffnen" um die Berechtigung zu erteilen.';
  } else {
    return '🔒 GPS-Berechtigung erforderlich!\n\n' +
      'Bitte erlaube den Standortzugriff in den iOS-Einstellungen.';
  }
};